import React from "react";
import { observer } from "mobx-react";
import { GrossReceiptsStatusCreateStore } from "../../store";
import { GrossReceiptsStatusCreateForm } from "./GrossReceiptsStatusCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type GrossReceiptsStatusCreateProps = {
  grossReceiptsStatusCreateStore: GrossReceiptsStatusCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const GrossReceiptsStatusCreate: React.FC<GrossReceiptsStatusCreateProps> =
  observer(
    ({
      grossReceiptsStatusCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={grossReceiptsStatusCreateStore.isSaving} />
          <GrossReceiptsStatusCreateForm
            grossReceiptsStatusCreateStore={grossReceiptsStatusCreateStore}
            name_esError={
              grossReceiptsStatusCreateStore.errors.name_es?.message
            }
            onName_esChange={(value: string) => {
              grossReceiptsStatusCreateStore.setName_esValue(value);
            }}
            name_es={grossReceiptsStatusCreateStore.entityValues.name_es}
            name_enError={
              grossReceiptsStatusCreateStore.errors.name_en?.message
            }
            onName_enChange={(value: string) => {
              grossReceiptsStatusCreateStore.setName_enValue(value);
            }}
            name_en={grossReceiptsStatusCreateStore.entityValues.name_en}
            name_ptError={
              grossReceiptsStatusCreateStore.errors.name_pt?.message
            }
            onName_ptChange={(value: string) => {
              grossReceiptsStatusCreateStore.setName_ptValue(value);
            }}
            name_pt={grossReceiptsStatusCreateStore.entityValues.name_pt}
            description_esError={
              grossReceiptsStatusCreateStore.errors.description_es?.message
            }
            onDescription_esChange={(value: string) => {
              grossReceiptsStatusCreateStore.setDescription_esValue(value);
            }}
            description_es={
              grossReceiptsStatusCreateStore.entityValues.description_es
            }
            description_enError={
              grossReceiptsStatusCreateStore.errors.description_en?.message
            }
            onDescription_enChange={(value: string) => {
              grossReceiptsStatusCreateStore.setDescription_enValue(value);
            }}
            description_en={
              grossReceiptsStatusCreateStore.entityValues.description_en
            }
            description_ptError={
              grossReceiptsStatusCreateStore.errors.description_pt?.message
            }
            onDescription_ptChange={(value: string) => {
              grossReceiptsStatusCreateStore.setDescription_ptValue(value);
            }}
            description_pt={
              grossReceiptsStatusCreateStore.entityValues.description_pt
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={grossReceiptsStatusCreateStore.isProcessing}
            onSave={() =>
              grossReceiptsStatusCreateStore.saveNewGrossReceiptsStatus()
            }
            onCancel={() =>
              grossReceiptsStatusCreateStore.cancelNewGrossReceiptsStatus()
            }
          />
          <ErrorDialog
            open={grossReceiptsStatusCreateStore.errorDialogOpened}
            title={grossReceiptsStatusCreateStore.errorTitle}
            description={grossReceiptsStatusCreateStore.errorDescription}
            onClose={() => grossReceiptsStatusCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
